import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Accessor$getterNotNull$ref2ndsuv51xxzcf as Accessor$getterNotNull$ref,
  Accessor$getterNotNull$ref2erj3mglm0f6i as Accessor$getterNotNull$ref_0,
  Accessor$getterNotNull$ref3scn6v6deccs as Accessor$getterNotNull$ref_1,
} from './FieldSpec.mjs';
import {
  UnsignedIntFormatterStructure2iqfxgv3d2ejy as UnsignedIntFormatterStructure,
  StringFormatterStructure3i97mc47fm0qc as StringFormatterStructure,
  DecimalFractionFormatterStructure2fby7dmyhkzn1 as DecimalFractionFormatterStructure,
  SignedIntFormatterStructureuogj4y4pj858 as SignedIntFormatterStructure,
} from './formatter/FormatterOperation.mjs';
import { SpacePaddedFormatter1bbtqhbgrvf8v as SpacePaddedFormatter } from './formatter/Formatter.mjs';
import {
  spaceAndZeroPaddedUnsignedInt3iec50j4qusnr as spaceAndZeroPaddedUnsignedInt,
  StringSetParserOperation82b6pl2fn98q as StringSetParserOperation,
  NumberSpanParserOperation3qyp02c4km7yu as NumberSpanParserOperation,
  SignedIntParsergn6823y2nf4q as SignedIntParser,
} from './parser/ParserOperation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getOrNull1go7ef9ldk0df as getOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ParserStructure2cqp7gjft5io4 as ParserStructure } from './parser/Parser.mjs';
import { FractionPartConsumerf0mxqojimz2s as FractionPartConsumer } from './parser/NumberConsumer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UnsignedIntFieldFormatDirectiveClass;
function UnsignedIntFieldFormatDirective() {
  if (UnsignedIntFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, minDigits, spacePadding) {
        this.field_1 = field;
        this.minDigits_1 = minDigits;
        this.spacePadding_1 = spacePadding;
        this.maxDigits_1 = this.field_1.maxDigits_1;
        // Inline function 'kotlin.require' call
        if (!(this.minDigits_1 >= 0)) {
          var message = 'The minimum number of digits (' + this.minDigits_1 + ') is negative';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.maxDigits_1 >= this.minDigits_1)) {
          var message_0 = 'The maximum number of digits (' + this.maxDigits_1 + ') is less than the minimum number of digits (' + this.minDigits_1 + ')';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        if (!(this.spacePadding_1 == null)) {
          // Inline function 'kotlin.require' call
          if (!(this.spacePadding_1 > this.minDigits_1)) {
            var message_1 = 'The space padding (' + this.spacePadding_1 + ') should be more than the minimum number of digits (' + this.minDigits_1 + ')';
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
          }
        }
      }
      get_field_irdnf5_k$() {
        return this.field_1;
      }
      formatter_tykoui_k$() {
        var formatter = new (UnsignedIntFormatterStructure())(Accessor$getterNotNull$ref(this.field_1.accessor_1), this.minDigits_1);
        return !(this.spacePadding_1 == null) ? new (SpacePaddedFormatter())(formatter, this.spacePadding_1) : formatter;
      }
      parser_ggn3z5_k$() {
        return spaceAndZeroPaddedUnsignedInt(this.minDigits_1, this.maxDigits_1, this.spacePadding_1, this.field_1.accessor_1, this.field_1.name_1);
      }
    }
    initMetadataForClass($, 'UnsignedIntFieldFormatDirective');
    UnsignedIntFieldFormatDirectiveClass = $;
  }
  return UnsignedIntFieldFormatDirectiveClass;
}
function getStringValue($this, target) {
  // Inline function 'kotlin.let' call
  var it = $this.field_1.accessor_1.getterNotNull_rjcshh_k$(target);
  var tmp0_elvis_lhs = getOrNull($this.values_1, it - $this.field_1.minValue_1 | 0);
  return tmp0_elvis_lhs == null ? 'The value ' + it + ' of ' + $this.field_1.name_1 + ' does not have a corresponding string representation' : tmp0_elvis_lhs;
}
var AssignableStringClass;
function AssignableString() {
  if (AssignableStringClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
      }
      trySetWithoutReassigning_nj495f_k$(container, newValue) {
        var tmp0_safe_receiver = this.$this_1.field_1.accessor_1.trySetWithoutReassigning_itlg4a_k$(container, this.$this_1.values_1.indexOf_si1fv9_k$(newValue) + this.$this_1.field_1.minValue_1 | 0);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.$this_1.values_1.get_c1px32_k$(tmp0_safe_receiver - this.$this_1.field_1.minValue_1 | 0);
        }
        return tmp;
      }
      trySetWithoutReassigning_itlg4a_k$(container, newValue) {
        return this.trySetWithoutReassigning_nj495f_k$(container, (!(newValue == null) ? typeof newValue === 'string' : false) ? newValue : THROW_CCE());
      }
      get_name_woqyms_k$() {
        return this.$this_1.name_1;
      }
    }
    initMetadataForClass($, 'AssignableString');
    AssignableStringClass = $;
  }
  return AssignableStringClass;
}
function NamedUnsignedIntFieldFormatDirective$getStringValue$ref(p0) {
  return constructCallableReference((p0_0) => {
    var tmp0 = p0;
    return getStringValue(tmp0, p0_0);
  }, 1, 0, 59, 'getStringValue', [p0]);
}
var NamedUnsignedIntFieldFormatDirectiveClass;
function NamedUnsignedIntFieldFormatDirective() {
  if (NamedUnsignedIntFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, values, name) {
        this.field_1 = field;
        this.values_1 = values;
        this.name_1 = name;
        // Inline function 'kotlin.require' call
        if (!(this.values_1.get_size_woubt6_k$() === ((this.field_1.maxValue_1 - this.field_1.minValue_1 | 0) + 1 | 0))) {
          var message = 'The number of values (' + this.values_1.get_size_woubt6_k$() + ') in ' + toString(this.values_1) + ' does not match the range of the field (' + ((this.field_1.maxValue_1 - this.field_1.minValue_1 | 0) + 1 | 0) + ')';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      get_field_irdnf5_k$() {
        return this.field_1;
      }
      formatter_tykoui_k$() {
        return new (StringFormatterStructure())(NamedUnsignedIntFieldFormatDirective$getStringValue$ref(this));
      }
      parser_ggn3z5_k$() {
        return new (ParserStructure())(listOf(new (StringSetParserOperation())(this.values_1, new (AssignableString())(this), 'one of ' + toString(this.values_1) + ' for ' + this.name_1)), emptyList());
      }
    }
    initMetadataForClass($, 'NamedUnsignedIntFieldFormatDirective');
    NamedUnsignedIntFieldFormatDirectiveClass = $;
  }
  return NamedUnsignedIntFieldFormatDirectiveClass;
}
var DecimalFractionFieldFormatDirectiveClass;
function DecimalFractionFieldFormatDirective() {
  if (DecimalFractionFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, minDigits, maxDigits, zerosToAdd) {
        this.field_1 = field;
        this.minDigits_1 = minDigits;
        this.maxDigits_1 = maxDigits;
        this.zerosToAdd_1 = zerosToAdd;
      }
      get_field_irdnf5_k$() {
        return this.field_1;
      }
      formatter_tykoui_k$() {
        return new (DecimalFractionFormatterStructure())(Accessor$getterNotNull$ref_0(this.field_1.get_accessor_3q8qa8_k$()), this.minDigits_1, this.maxDigits_1, this.zerosToAdd_1);
      }
      parser_ggn3z5_k$() {
        return new (ParserStructure())(listOf(new (NumberSpanParserOperation())(listOf(new (FractionPartConsumer())(this.minDigits_1, this.maxDigits_1, this.field_1.get_accessor_3q8qa8_k$(), this.field_1.get_name_woqyms_k$())))), emptyList());
      }
    }
    initMetadataForClass($, 'DecimalFractionFieldFormatDirective');
    DecimalFractionFieldFormatDirectiveClass = $;
  }
  return DecimalFractionFieldFormatDirectiveClass;
}
var SignedIntFieldFormatDirectiveClass;
function SignedIntFieldFormatDirective() {
  if (SignedIntFieldFormatDirectiveClass === VOID) {
    class $ {
      constructor(field, minDigits, maxDigits, spacePadding, outputPlusOnExceededWidth) {
        this.field_1 = field;
        this.minDigits_1 = minDigits;
        this.maxDigits_1 = maxDigits;
        this.spacePadding_1 = spacePadding;
        this.outputPlusOnExceededWidth_1 = outputPlusOnExceededWidth;
        // Inline function 'kotlin.require' call
        if (!(this.minDigits_1 == null || this.minDigits_1 >= 0)) {
          var message = 'The minimum number of digits (' + this.minDigits_1 + ') is negative';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.maxDigits_1 == null || this.minDigits_1 == null || this.maxDigits_1 >= this.minDigits_1)) {
          var message_0 = 'The maximum number of digits (' + this.maxDigits_1 + ') is less than the minimum number of digits (' + this.minDigits_1 + ')';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
      }
      get_field_irdnf5_k$() {
        return this.field_1;
      }
      formatter_tykoui_k$() {
        var tmp = Accessor$getterNotNull$ref_1(this.field_1.get_accessor_3q8qa8_k$());
        var tmp0_elvis_lhs = this.minDigits_1;
        var formatter = new (SignedIntFormatterStructure())(tmp, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, this.outputPlusOnExceededWidth_1);
        return !(this.spacePadding_1 == null) ? new (SpacePaddedFormatter())(formatter, this.spacePadding_1) : formatter;
      }
      parser_ggn3z5_k$() {
        return SignedIntParser(this.minDigits_1, this.maxDigits_1, this.spacePadding_1, this.field_1.get_accessor_3q8qa8_k$(), this.field_1.get_name_woqyms_k$(), this.outputPlusOnExceededWidth_1);
      }
    }
    initMetadataForClass($, 'SignedIntFieldFormatDirective');
    SignedIntFieldFormatDirectiveClass = $;
  }
  return SignedIntFieldFormatDirectiveClass;
}
//region block: exports
export {
  DecimalFractionFieldFormatDirective as DecimalFractionFieldFormatDirective1h9sbm886izzq,
  NamedUnsignedIntFieldFormatDirective as NamedUnsignedIntFieldFormatDirective1yq6ki9eqgm4v,
  SignedIntFieldFormatDirective as SignedIntFieldFormatDirective2ce7tjucbhgd2,
  UnsignedIntFieldFormatDirective as UnsignedIntFieldFormatDirective20kfpdbszyixg,
};
//endregion

//# sourceMappingURL=FieldFormatDirective.mjs.map
